import { useState, useEffect } from "react"
import axios from "axios"
import styled from "styled-components"
import UserMenu from "./UserMenu"
import { useAuthStore } from "../store/store"
import moment from "moment"
import { toast, Toaster } from 'react-hot-toast';
import { getAddresses } from "../service/addressService"
import PageHeader from "../components/PageCloseButton";
import { FaTrashAlt } from "react-icons/fa"

const UserAddressList = () => {
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const { auth } = useAuthStore();
  useEffect(() => {
    const loadAddresses = async () => {
      try {
        const data = await getAddresses();
        setAddresses(data);
      } catch (error) {
        toast.error("Unable to load addresses");
      }
    };
    loadAddresses();
  }, []);

  const handleAddress = (idx) => {
    setSelectedAddress(addresses[idx]);
  };


  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this address?");
    if (!confirmDelete) return;

    try {
      const token = auth?.token;
      await axios.delete(`${process.env.REACT_APP_SERVER_DOMAIN}/api/address/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Address deleted successfully");
      setAddresses((prev) => prev.filter((addr) => addr._id !== id));
    } catch (error) {
      toast.error("Failed to delete address");
    }
  };
  return (
    <Wrapper>
      <div className="grid grid-two-column">
        <UserMenu />
        <div className="address-container">
          <PageHeader title="Address List" />
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Country</th>
                  <th>Zip/Postal Code</th>
                  <th>Phone No</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {addresses.map((addr, idx) => (
                  <tr key={idx} onClick={() => handleAddress(idx)}>
                    <td>{idx + 1}</td>
                    <td>{addr.name}</td>
                    <td>{addr.street_add}</td>
                    <td>{addr.city}</td>
                    <td>{addr.state_province}</td>
                    <td>{addr.country}</td>
                    <td>{addr.zipcode}</td>
                    <td> (+{addr.isdCode})  {addr.phone}</td>
                    <td><FaTrashAlt
                      className="remove_icon"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent row click
                        handleDelete(addr._id);
                      }}
                      style={{ cursor: "pointer", color: "red" }}
                    /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Wrapper >
  )
}
const Wrapper = styled.div`

  .grid-two-column{
      display: grid;
      grid-template-columns: 2fr 8fr;
      gap: 2rem;
      }

  .address-container{
      padding: 2rem;   
      }

  .table-container {
      margin-top:2rem;
      margin-bottom:2rem;
      max-height: 400px;
      overflow-y: auto;
      border: 1px solid #ddd;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      }

  table {
      margin:2rem ;
      width: 97%;
      border-collapse: collapse;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      }
    
  thead {
      background-color: ${({ theme }) => theme.colors.font};
      color: #fff;
    }

  thead th {
      position: sticky;
      top: 0;
      padding: 12px;
      font-size: 14px;
      text-align: left;
      letter-spacing: 0.5px;
      z-index: 2;
      }

  tbody tr {
      border-bottom: 1px solid #eee;
      transition: 0.2s ease;
      }

  tbody tr:hover {
    background-color: #f9f9f9;
    }

  td {
    padding: 12px;
    font-size: 14px;
    vertical-align: top;
    }

  .remove_icon {
    cursor: pointer;
    color: red;
    font-size: 2.5rem;
  } 
  
  
@media (max-width: ${({ theme }) => theme.media.mobile}) {

  .grid {
    grid-template-columns: 1fr;
    }

  table, thead, tbody, th, td, tr {
      display: block; 
      }

  table, thead, tbody, th, td, tr {
      width: 97%;
     }

  thead {
      display: none;
      }

  tr {
      margin-bottom: 1rem;
      border: 1px solid #ddd;
      padding: 0.2rem;
      border-radius: 6px;
      }

  td {
      border: none;
      position: relative;
       padding: 0.5rem 0.5rem 0.5rem 1rem;
      }

  td::before {
      position: absolute;
      left: 0.2rem;
      font-weight: bold;
      content: attr(data-label); 
      }
    }
`;

export default UserAddressList